import React from 'react';
import Notification, { NotificationProps } from './notification';

interface NotificationContainerProps {
  notifications: NotificationProps[];
  onRemove: (id: string) => void;
}

const NotificationContainer: React.FC<NotificationContainerProps> = ({
  notifications,
  onRemove,
}) => {
  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-80 max-w-[calc(100vw-2rem)] sm:w-96 space-y-3 pointer-events-none">
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          className="pointer-events-auto w-full"
          style={{
            zIndex: 1000 - index,
          }}
        >
          <Notification
            {...notification}
            onClose={onRemove}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer; 